import React from 'react';
import createForm from "./Form";
import Head from "./Invoice/Fields/Head";
import Items from "./Invoice/Fields/Items";

class invoiceForm extends React.Component {

    render() {
        const disabled = this.props.values[this.props.componentConfig.idfield];

        return (
            <form onSubmit={this.props.handleSubmit}>
                <Head {...this.props} disabled={disabled}/>
                <Items {...this.props} />
            </form>
        );
    }
}

export default createForm(invoiceForm);
